import axios from "axios";
import swal from "sweetalert2";
import parse from "html-react-parser";

import { useState, useEffect } from "react";
import { Link, useParams, useNavigate } from "react-router-dom";
import { globalState, accessTokenKey, baseUrl, isPremium } from "../utils/config";

import Loader from "./layouts/Loader";

function FeatureJob () {
    const { id } = useParams();
    const navigate = useNavigate();
    
    const [job, setJob] = useState(null);
    const [bank, setBank] = useState(null);
    const [loading, setLoading] = useState(false);
    const [loadingBank, setLoadingBank] = useState(false);
    const [uploadingReceipt, setUploadingReceipt] = useState(false);
    const [state, setState] = useState(globalState.state);
    const [stripe, setStripe] = useState(null);
    const [cardElement, setCardElement] = useState(null);
    const [payingViaStripe, setPayingViaStripe] = useState(false);

    async function fetch() {
        setLoading(true);

        try {
            const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
            const formData = new FormData();
            formData.append("id", id);
            formData.append("time_zone", timeZone);

            const response = await axios.post(
                baseUrl + "/api/jobs/fetch-single",
                formData,
                {
                    headers: {
                        Authorization: "Bearer " + localStorage.getItem(accessTokenKey)
                    },

                    withCredentials: true
                }
            );

            if (response.data.status == "success") {
                setJob(response.data.job);
            } else {
                swal.fire("Error", response.data.message, "error");
            }
        } catch (exp) {
            console.log(exp.message);
        } finally {
            setLoading(false);
        }
    }

    async function fetchBankDetails() {
        setLoadingBank(true);

        try {
            const formData = new FormData();
            formData.append("type", "feature_job");

            const response = await axios.post(
                baseUrl + "/api/fetch-bank",
                formData,
                {
                    headers: {
                        Authorization: "Bearer " + localStorage.getItem(accessTokenKey)
                    }
                }
            );

            if (response.data.status == "success") {
                setBank(response.data.bank);
            } else {
                swal.fire("Error", response.data.message, "error");
            }
        } catch (exp) {
            console.log(exp.message);
        } finally {
            setLoadingBank(false);
        }
    }

    async function uploadReceipt() {
        setUploadingReceipt(true);

        try {
            const form = document.getElementById("form-upload-receipt");
            const formData = new FormData(form);
            formData.append("id", id);

            const response = await axios.post(
                baseUrl + "/api/jobs/upload-receipt",
                formData,
                {
                    headers: {
                        Authorization: "Bearer " + localStorage.getItem(accessTokenKey)
                    }
                }
            );

            if (response.data.status == "success") {
                swal.fire("Upload Receipt", response.data.message, "success");
            } else {
                swal.fire("Error", response.data.message, "error");
            }
        } catch (exp) {
            console.log(exp.message);
        } finally {
            setUploadingReceipt(false);
        }
    }

    async function payViaStripe() {
        if (state.user == null) {
            return;
        }

        setPayingViaStripe(true);

        try {
            const formData = new FormData();
            formData.append("id", id);
            formData.append("type", "feature_job");

            const response = await axios.post(
                baseUrl + "/api/payments/fetch-stripe-intent",
                formData,
                {
                    headers: {
                        Authorization: "Bearer " + localStorage.getItem(accessTokenKey)
                    }
                }
            );

            if (response.data.status == "success") {
                const clientSecret = response.data.client_secret;

                // execute the payment
                stripe
                    .confirmCardPayment(clientSecret, {
                        payment_method: {
                                card: cardElement,
                                billing_details: {
                                    "email": state.user.email,
                                    "name": state.user.name,
                                    // "phone": 0
                                },
                            },
                        })
                        .then(async function(result) {
             
                            // Handle result.error or result.paymentIntent
                            if (result.error) {
                                console.log(result.error);
                                swal.fire("Error", result.error, "error");
                                setPayingViaStripe(false);
                            } else {
                                console.log("The card has been verified successfully...", result.paymentIntent.id);
             
                                try {
                                    const formData2 = new FormData();
                                    formData2.append("id", id);
                                    formData2.append("type", "feature_job");
                                    formData2.append("payment_id", result.paymentIntent.id);

                                    const response2 = await axios.post(
                                        baseUrl + "/api/payments/verify-stripe",
                                        formData2,
                                        {
                                            headers: {
                                                Authorization: "Bearer " + localStorage.getItem(accessTokenKey)
                                            }
                                        }
                                    );

                                    if (response2.data.status == "success") {
                                        swal.fire("Feature Job", response2.data.message, "success")
                                            .then(function () {
                                                navigate("/jobs/" + id);
                                            });
                                    } else {
                                        swal.fire("Error", response2.data.message, "error");
                                    }
                                } catch (exp) {
                                    //
                                } finally {
                                    setPayingViaStripe(false);
                                }
                            }
                        });
            } else {
                swal.fire("Error", response.data.message, "error");
                setPayingViaStripe(false);
            }
        } catch (exp) {
            console.log(exp.message);
            setPayingViaStripe(false);
        }
    }

    useEffect(function () {
        fetch();
        fetchBankDetails();

        globalState.listen(function (newState, updatedState) {
            setState(newState);

            if (typeof updatedState.settings !== "undefined") {
                if (typeof updatedState.settings?.stripe_pk !== "undefined") {
                    
                    let interval = setInterval(function () {
                        if (typeof window.Stripe !== "undefined") {
                            var stripe = window.Stripe(updatedState.settings.stripe_pk);
                            var elements = stripe.elements();
                            var cardElement = elements.create('card');
                            cardElement.mount('#stripe-card-element');

                            setStripe(stripe);
                            setCardElement(cardElement);

                            clearInterval(interval);
                        }
                    }, 3000);
                }
            }
        });

        if (typeof state.settings !== "undefined") {
            if (typeof state.settings?.stripe_pk !== "undefined") {
                
                let interval2 = setInterval(function () {
                    if (typeof window.Stripe !== "undefined") {
                        var stripe = window.Stripe(state.settings.stripe_pk);
                        var elements = stripe.elements();
                        var cardElement = elements.create('card');
                        cardElement.mount('#stripe-card-element');

                        setStripe(stripe);
                        setCardElement(cardElement);

                        clearInterval(interval2);
                    }
                }, 3000);
            }
        }
    }, []);

    return (
        <>
            <div className="container-xxl py-5 bg-dark page-header mb-5">
                <div className="container my-5 pt-5 pb-4">
                    <h1 className="display-3 text-white mb-3 animated slideInDown">{ job?.title }</h1>
                    <nav aria-label="breadcrumb">
                        <ol className="breadcrumb text-uppercase">
                            <li className="breadcrumb-item"><Link to="/">Home</Link></li>
                            <li className="breadcrumb-item"><Link to="/jobs">Jobs</Link></li>
                            <li className="breadcrumb-item text-white active" aria-current="page">{ job?.title }</li>
                            <li className="breadcrumb-item text-white active" aria-current="page">Feature</li>
                        </ol>
                    </nav>
                </div>
            </div>

            { loading && (
                <div className="container-xxl py-5 wow fadeInUp" data-wow-delay="0.1s">
                    <div className="container">
                        <div className="row gy-5 gx-4">
                            <div className="col-md-12 text-center">
                                <Loader />
                            </div>
                        </div>
                    </div>
                </div>
            ) }
            
            <div className="container-xxl py-0 wow fadeInUp" data-wow-delay="0.1s">
                <div className="container">

                    { (job != null && state.user?.id == job.user.id && job.is_featured == 0) && (
                        <>
                            <div className="row mb-3">
                                <div className="offset-md-2 col-md-8">
                                    <h2>{ job.title }</h2>
                                    <p>Feature your job to appear on the homepage and at the top of search results for 30 days. <strong>3× more visibility</strong>. <strong>Faster hires</strong>. Get the attention your job deserves for just <b className="text-primary">${ job.feature_price_per_month } for 30 days</b></p>
                                </div>
                            </div>

                            <ul className="nav nav-pills mb-3" id="pills-tab" role="tablist">
                                <li className="nav-item" role="presentation">
                                    <button className="nav-link active" id="pills-bank-transfer-tab" data-bs-toggle="pill" data-bs-target="#pills-bank-transfer" type="button" role="tab" aria-controls="pills-bank-transfer" aria-selected="true">Bank Transfer</button>
                                </li>

                                <li className="nav-item" role="presentation">
                                    <button className="nav-link" id="pills-stripe-tab" data-bs-toggle="pill" data-bs-target="#pills-stripe" type="button" role="tab" aria-controls="pills-stripe" aria-selected="false">Stripe</button>
                                </li>

                                {/*<li className="nav-item" role="presentation">
                                    <button className="nav-link" id="pills-paypal-tab" data-bs-toggle="pill" data-bs-target="#pills-paypal" type="button" role="tab" aria-controls="pills-paypal" aria-selected="false">PayPal</button>
                                </li>*/}
                            </ul>
                            
                            <div className="tab-content" id="pills-tabContent">
                                <div className="tab-pane fade show active" id="pills-bank-transfer" role="tabpanel" aria-labelledby="pills-bank-transfer-tab">
                                    <div className="row">
                                        <div className="col-md-4">
                                            <div className="d-flex align-items-center mb-5">
                                                <div className="bg-light rounded p-5 wow slideInUp" data-wow-delay="0.1s">
                                                    <h4 className="mb-4">Bank Transfer Details:</h4>

                                                    { loadingBank ? (
                                                        <Loader />
                                                    ) : (
                                                        <>
                                                            <p><i className="fa fa-angle-right text-primary me-2"></i>Bank: { bank?.bank_name }</p>
                                                            <p><i className="fa fa-angle-right text-primary me-2"></i>Account Name: { bank?.account_name }</p>
                                                            <p><i className="fa fa-angle-right text-primary me-2"></i>Account Number: { bank?.account_number }</p>
                                                            <p><i className="fa fa-angle-right text-primary me-2"></i>IBAN: { bank?.iban }</p>
                                                            <p><i className="fa fa-angle-right text-primary me-2"></i>Swift Code: { bank?.swift_code }</p>

                                                            { bank?.method && (
                                                                <p><i className="fa fa-angle-right text-primary me-2"></i>Method: { bank?.method }</p>
                                                            ) }
                                                        </>
                                                    ) }
                                                </div>
                                            </div>
                                        </div>

                                        <div className="col-md-8">
                                            <h2 className="mt-5">Upload Payment Receipt</h2>
                                            <p>Once you have made the payment, you can upload the receipt here.</p>

                                            <form onSubmit={ function (event) {
                                                event.preventDefault();
                                                uploadReceipt();
                                            } } encType="multipart/form-data" id="form-upload-receipt">
                                                <div className="row g-3">
                                                    <div className="col-md-6">
                                                        <div className="form-floating">
                                                            <input type="file" className="form-control bg-white" name="file"
                                                                accept=".pdf, image/*"
                                                                required />
                                                        </div>
                                                    </div>

                                                    <div className="col-md-6">
                                                        <button className={ isPremium ? "btn btn-primary w-100 py-3" : "btn premium-bg premium-border w-100 py-3" } type="submit"
                                                            disabled={ uploadingReceipt }>Upload</button>
                                                    </div>
                                                </div>
                                            </form>
                                        </div>
                                    </div>
                                </div>

                                <div className="tab-pane fade" id="pills-stripe" role="tabpanel" aria-labelledby="pills-stripe-tab">
                                    <div className="row">
                                        <div className="col-md-12">
                                            <div className="rounded p-5 wow slideInUp" data-wow-delay="0.1s">
                                                <h4 className="mb-4">Stripe (demo)</h4>

                                                <div id="stripe-card-element"></div>

                                                { stripe != null && (
                                                    <button type="button" className={ isPremium ? "btn btn-outline-primary mt-3" : "btn premium-bg premium-border mt-3" }
                                                        onClick={ function () {
                                                            payViaStripe();
                                                        } } disabled={ payingViaStripe }>Pay ${ job.feature_price_per_month }</button>
                                                ) }
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                {/*<div className="tab-pane fade" id="pills-paypal" role="tabpanel" aria-labelledby="pills-paypal-tab">..3.</div>*/}
                            </div>
                        </>
                    ) }

                </div>
            </div>
        </>
    );
}

export default FeatureJob;